import styled from 'styled-components';

export const CheckboxsContainer = styled.div`
  height: 100%;
  width: 100%;
  display: grid;
  /* grid-template-columns: 50% 50%; */
  border-radius: 4px;
  grid-template-rows: 1fr 1fr;
  grid-template-columns: 1fr 1fr;
  /* You can change margin to whatever you want it to be */
  --margin: 8px;
  height: 100% !important;
  width: 100% !important;
  grid-gap: calc(2 * var(--margin));
  gap: var(--margin);
`;
